/**
 * apiUrl.js
 * Centralized API & WebSocket Gateway URL resolver for Kisan Mithr.
 * 
 * Dynamically resolves URLs so that:
 * - On desktop localhost: connects to localhost:5000
 * - On physical mobile devices over Wi-Fi / LAN (e.g. 192.168.x.x:3000):
 *   automatically targets http://<LAN-IP>:5000 instead of failing on mobile localhost
 * - In production domains: uses the configured REACT_APP_API_URL or relative origin
 */

export const getBackendBaseUrl = () => {
  const configured = process.env.REACT_APP_API_URL || "http://localhost:5000";

  if (typeof window !== "undefined" && window.location) {
    const { hostname, protocol } = window.location;

    // If running on a local network IP or mobile device (not localhost / 127.0.0.1)
    if (hostname && hostname !== "localhost" && hostname !== "127.0.0.1") {
      try {
        const parsed = new URL(configured);
        // If the configured URL was pointing to localhost, swap to the current machine's LAN IP
        if (parsed.hostname === "localhost" || parsed.hostname === "127.0.0.1") {
          parsed.hostname = hostname;
          parsed.protocol = protocol || "http:";
          return parsed.origin;
        }
      } catch (e) {
        return `${protocol || "http:"}//${hostname}:5000`;
      }
    }
  }

  return configured;
};

export const getApiBaseUrl = () => {
  const base = getBackendBaseUrl();
  return base.endsWith("/api") ? base : `${base}/api`;
};

export default getBackendBaseUrl;
